import type { IObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation } from './ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation.interface';

export default class ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation
  implements IObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation {
  reducedRepayments: boolean;
  reducedRepaymentsComments: string;
  lowerInterestRate: boolean;
  lowerInterestRateComments: string;
  increaseTotalLoanAmount: boolean;
  greaterFlexibility: boolean;
  greaterFlexibilityComments: string;
  reduceNumberOfLenders: boolean;
  reduceNumberOfLendersComments: string;
  dissatisfiedWithOtherFinancialInstitution: boolean;
  dissatisfiedWithOtherFinancialInstitutionComments: string;
  closeToEndOfCurrentLoanTerm: boolean;
  closeToEndOfCurrentLoanTermComments: string;
  other: boolean;
  otherComments: string;

  static build = (data: IObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation) =>
    new ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation(data);

  static blank = () => new ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation();

  /**
   * Constructor
   * @param {IObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation} data
   */
  constructor(data?: IObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation) {
    this.reducedRepayments = data?.reducedRepayments === true;
    this.reducedRepaymentsComments = data?.reducedRepaymentsComments || '';
    this.lowerInterestRate = data?.lowerInterestRate === true;
    this.lowerInterestRateComments = data?.lowerInterestRateComments || '';
    this.increaseTotalLoanAmount = data?.increaseTotalLoanAmount === true;
    this.greaterFlexibility = data?.greaterFlexibility === true;
    this.greaterFlexibilityComments = data?.greaterFlexibilityComments || '';
    this.reduceNumberOfLenders = data?.reduceNumberOfLenders === true;
    this.reduceNumberOfLendersComments = data?.reduceNumberOfLendersComments || '';
    this.dissatisfiedWithOtherFinancialInstitution =
      data?.dissatisfiedWithOtherFinancialInstitution === true;
    this.dissatisfiedWithOtherFinancialInstitutionComments =
      data?.dissatisfiedWithOtherFinancialInstitutionComments || '';
    this.closeToEndOfCurrentLoanTerm = data?.closeToEndOfCurrentLoanTerm === true;
    this.closeToEndOfCurrentLoanTermComments = data?.closeToEndOfCurrentLoanTermComments || '';
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
  }
}
